/** Characters a card id may not hold (host contract §3.3: `^[A-Za-z0-9_.:-]{1,64}$`). */
const CARD_ID_UNSAFE = /[^A-Za-z0-9_.:-]/g;
export const CARD_ID_MAX_LENGTH = 64;

/** `prefix:suffix` as a valid card id: other characters become «-», cut at 64. */
export function cardId(prefix: string, suffix: string): string {
  return `${prefix}:${suffix}`
    .replace(CARD_ID_UNSAFE, '-')
    .slice(0, CARD_ID_MAX_LENGTH);
}

/**
 * The id of a card a tool call shows: unique in the conversation, because
 * each tool call has its own request id (a random one when it is missing).
 */
export function toolCardId(prefix: string, requestId: string): string {
  const suffix =
    requestId ||
    `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  return cardId(prefix, suffix);
}
